import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Container } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import { useNProgress } from '@tanem/react-nprogress';
import useProgressContext from 'src/hooks/useProgressContext';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

const useStyles = makeStyles((theme) => ({
  bar: ({ animationDuration }) => ({
    transitionDuration: `${animationDuration}ms`
  }),
  container: ({ animationDuration, isFinished }) => ({
    opacity: isFinished ? 0 : 1,
    pointerEvents: 'none',
    transition: `opacity ${animationDuration}ms linear`,
    zIndex: theme.zIndex.drawer + 1,
    position: 'fixed',
    top: 0,
    width: '100%'
  })
}));

const StyledLinearProgress = withStyles(() => ({
  bar1Determinate: {
    // backgroundColor: theme.palette.custom.textColor
  }
}))(LinearProgress);

export default function LinearProgressBar() {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isLoading = isFetching > 0 || isMutating > 0;
  const { isAnimating } = useProgressContext();
  const { progress, isFinished, animationDuration } = useNProgress({
    isAnimating: isAnimating || isLoading
  });
  const classes = useStyles({ animationDuration, isFinished });

  return (
    <Container
      classes={{ root: classes.container }}
      disableGutters
      maxWidth={false}
    >
      <StyledLinearProgress
        classes={{ bar1Determinate: classes.bar }}
        variant="determinate"
        value={isFinished ? 0 : progress * 100}
      />
    </Container>
  );
}
